const drone = {
  "page": {
    "loading": "កំពុងផ្ទុកអេក្រង់ដ្រូន...",
    "projectLoadFailed": "មិនអាចផ្ទុកព័ត៌មានទីតាំងការងារបានទេ",
    "projectNoLocation": "ទីតាំងការងារមិនមានទីតាំង ដូច្នេះមិនអាចគូរផែនទីបានទេ",
  },
  "sidebar": {
    "mapping": "ការធ្វើផែនទី",
    "settings": "ការកំណត់ដ្រូន",
  },
  "unavailable": {
    "title": "API ដ្រូនកំពុងរៀបចំ",
    "body": "Dock API មិនទាន់ត្រូវបានភ្ជាប់នៅឡើយទេ។ នៅក្នុងបរិយាកាសអភិវឌ្ឍន៍ អ្នកអាចមើលគំរូសាកល្បងដោយប្រើ NEXT_PUBLIC_DRONE_API=mock។",
  },
  "access": {
    "locked": "កំពុងពិនិត្យតួនាទី — ការគ្រប់គ្រងសរសេរត្រូវបានចាក់សោ",
    "viewer": "សិទ្ធិមើលប៉ុណ្ណោះ — មានតែ owner ទេដែលអាចបន្ថែម Dock ហោះហើរ បញ្ជា ឬកំណត់",
  },
  "error": {
    "unavailable": "API ដ្រូនមិនទាន់រួចរាល់នៅឡើយទេ",
    "forbidden": "គ្មានសិទ្ធិ — មានតែ owner ទេដែលអាចធ្វើបាន",
    "not_found": "រកមិនឃើញគោលដៅទេ",
    "conflict": "មិនអាចដំណើរការបានទេ ព្រោះមិនត្រូវនឹងស្ថានភាពបច្ចុប្បន្ន",
    "validation": "សូមពិនិត្យតម្លៃដែលបានបញ្ចូល",
    "dock_busy": "Dock កំពុងហោះហើរ ដូច្នេះមិនអាចធ្វើបានឥឡូវនេះទេ",
    "network": "មិនអាចផ្ញើសំណើបានទេ — សូមព្យាយាមម្តងទៀត",
    "unconfirmed": "មិនអាចបញ្ជាក់លទ្ធផលនៃសំណើបានទេ — សូមពិនិត្យបញ្ជីហោះហើរ និងស្ថានភាពយន្តហោះ",
  },
  "dockBar": {
    "aircraftChange": "បានឃើញយន្តហោះថ្មី {{sn}} — បញ្ជាក់ដើម្បីភ្ជាប់នឹងដុកនេះ",
    "aircraftConfirm": "ភ្ជាប់យន្តហោះ",
    "label": "ស្ថានីយដ្រូន",
    "add": "បន្ថែម Dock",
    "empty": "មិនមាន Dock ដែលបានចុះឈ្មោះទេ",
    "loadFailed": "មិនអាចផ្ទុកបញ្ជី Dock បានទេ",
    "retry": "ផ្ទុកឡើងវិញ",
    "unbound": "មិនទាន់ភ្ជាប់",
    "bindFailed": "ការ Bind បរាជ័យ",
    "flying": "កំពុងហោះហើរ",
    "resumeBinding": "បន្តការ Bind {{name}}",
    "noSelection": "សូមជ្រើសរើស Dock — មុខងារទាំងអស់ផ្តោតលើ Dock ដែលបានជ្រើស",
    "statusButton": "ស្ថានភាព និងពាក្យបញ្ជារបស់ {{name}}",
    "hmsCount": "HMS {{count}}",
    "hmsNone": "គ្មាន HMS",
  },
  "liveness": {
    "live": "ទទួលបានធម្មតា",
    "stale": "ការទទួលយឺត",
    "offline": "ក្រៅបណ្តាញ",
  },
  "status": {
    "altitude": "កម្ពស់ទាក់ទង",
    "dockTitle": "Dock",
    "aircraftTitle": "យន្តហោះ",
    "mode": "ម៉ូដការងារ",
    "cover": "គម្រប",
    "climate": "ត្រួតពិនិត្យអាកាសធាតុ",
    "temperature": "សីតុណ្ហភាពខាងក្នុង",
    "humidity": "សំណើម",
    "outsideTemperature": "សីតុណ្ហភាពខាងក្រៅ",
    "wind": "ល្បឿនខ្យល់",
    "network": "បណ្តាញ",
    "aircraftPower": "ថាមពលយន្តហោះ",
    "charge": "ការសាកយន្តហោះ",
    "flightMode": "ម៉ូដហោះហើរ",
    "battery": "ថ្ម",
    "remain": "ពេលហោះហើរដែលនៅសល់",
    "speed": "ល្បឿនផ្ដេក",
    "lastSeen": "ទទួលចុងក្រោយ {{time}}",
    "staleWarning": "មិនបានទទួលស្ថានភាពជាង ១០ វិនាទី",
    "noTelemetry": "មិនទាន់បានទទួលស្ថានភាពនៅឡើយទេ",
    "aircraftOff": "យន្តហោះបានបិទ ឬមិនបានភ្ជាប់",
    "commands": "ពាក្យបញ្ជា",
    "coverOpen": "បើកគម្រប",
    "coverClose": "បិទគម្រប",
    "powerOn": "បើកថាមពលយន្តហោះ",
    "powerOff": "បិទថាមពលយន្តហោះ",
    "busy": "មិនអាចប្រើពាក្យបញ្ជាគម្រប និងថាមពលយន្តហោះបានទេ ពេលកំពុងហោះហើរ",
    "remove": "ដក Dock ចេញ",
    "minutesSeconds": "{{minutes}} នាទី {{seconds}} វិនាទី",
    "commandSent": "បានផ្ញើពាក្យបញ្ជា",
    "commandFailed": "{{dock}} · ពាក្យបញ្ជា {{command}} បានបរាជ័យ — {{reason}}",
    "commandFailedNoReason": "{{dock}} · ពាក្យបញ្ជា {{command}} បានបរាជ័យ",
  },
  "enum": {
    "unknown": "មិនស្គាល់ ({{value}})",
    "dockMode": {
      "0": "រង់ចាំ",
      "1": "ការបំបាត់កំហុសនៅនឹងកន្លែង",
      "2": "ការបំបាត់កំហុសពីចម្ងាយ",
      "3": "កំពុងធ្វើបច្ចុប្បន្នភាព firmware",
      "4": "កំពុងធ្វើការ",
      "5": "ត្រូវការ Calibrate",
    },
    "cover": {
      "0": "បិទ",
      "1": "បើក",
      "2": "បើកពាក់កណ្តាល",
      "3": "ស្ថានភាពគម្របមិនប្រក្រតី",
    },
    "climate": {
      "0": "រង់ចាំ",
      "1": "កំពុងធ្វើឱ្យត្រជាក់",
      "2": "កំពុងធ្វើឱ្យក្តៅ",
      "3": "កំពុងកាត់បន្ថយសំណើម",
      "7": "កំពុងរៀបចំធ្វើឱ្យត្រជាក់",
      "8": "កំពុងរៀបចំធ្វើឱ្យក្តៅ",
    },
    "onOff": {
      "0": "បិទ",
      "1": "បើក",
    },
    "networkQuality": {
      "0": "គ្មានសញ្ញា",
      "1": "អន់ខ្លាំង",
      "2": "អន់",
      "3": "មធ្យម",
      "4": "ល្អ",
      "5": "ល្អខ្លាំង",
    },
    "aircraftMode": {
      "0": "រង់ចាំ",
      "1": "រៀបចំហោះឡើង",
      "2": "រួចរាល់ហោះឡើង",
      "3": "ហោះហើរដោយដៃ",
      "4": "ហោះឡើងស្វ័យប្រវត្តិ",
      "5": "ហោះហើរតាមផ្លូវ",
      "9": "ត្រឡប់ស្វ័យប្រវត្តិ",
      "10": "ចុះចតស្វ័យប្រវត្តិ",
      "11": "ចុះចតដោយបង្ខំ",
      "14": "មិនបានភ្ជាប់",
    },
  },
  "hms": {
    "title": "ការជូនដំណឹង HMS",
    "empty": "គ្មានការជូនដំណឹងកំពុងដំណើរការទេ",
    "inSky": "កើតឡើងពេលហោះហើរ",
    "code": "កូដ {{code}}",
    "level": {
      "0": "ជូនដំណឹង",
      "1": "ប្រុងប្រយ័ត្ន",
      "2": "ព្រមាន",
      "none": "គ្មានកម្រិត",
    },
  },
  "binding": {
    "passwordOnce": "ពាក្យសម្ងាត់បង្ហាញតែម្តង — សូមចម្លងឥឡូវនេះ",
    "moveAsk": "ដុក {{sn}} បានចុះបញ្ជីក្នុងគម្រោងផ្សេង។ ផ្លាស់ទីមកគម្រោងនេះ?",
    "moveConfirm": "ផ្លាស់ទីមកគម្រោងនេះ",
    "titleAdd": "បន្ថែម Dock",
    "titleResume": "បន្តការ Bind {{name}}",
    "stepsLabel": "ជំហានភ្ជាប់",
    "steps": {
      "1": "ព័ត៌មាន Dock",
      "2": "តម្លៃភ្ជាប់",
      "3": "បញ្ចូលក្នុងកម្មវិធី",
      "4": "ពិនិត្យការតភ្ជាប់",
    },
    "currentStep": "ជំហានទី {{index}} / 4 — {{name}}",
    "snLabel": "SN របស់ Dock",
    "snHelp": "លេខស៊េរីនៅលើស្លាកខាងក្រោយ Dock ឬក្នុងព័ត៌មានឧបករណ៍នៃកម្មវិធី DJI",
    "nameLabel": "ឈ្មោះ Dock",
    "register": "ទទួលតម្លៃភ្ជាប់",
    "problem": {
      "snRequired": "សូមបញ្ចូល SN",
      "snFormat": "សូមប្រើអក្សរធំ និងលេខ ៦–៣២ តួ",
      "snDuplicate": "SN នេះត្រូវបានចុះឈ្មោះរួចហើយក្នុងគម្រោងនេះ",
      "nameRequired": "សូមបញ្ចូលឈ្មោះ",
      "nameTooLong": "សូមបញ្ចូលមិនលើស ៤០ តួអក្សរ",
    },
    "field": {
      "mqttPassword": "ពាក្យសម្ងាត់ MQTT",
      "org_id": "លេខសម្គាល់អង្គភាព",
      "org_name": "ឈ្មោះអង្គភាព",
      "binding_code": "កូដ Bind",
      "mqtt": "អាសយដ្ឋាន MQTT gateway",
      "mqttUser": "គណនី MQTT",
      "ntp": "ម៉ាស៊ីនបម្រើ NTP",
    },
    "onceNotice": "តម្លៃទាំងនេះបង្ហាញតែម្តងគត់ឥឡូវនេះ។ ប្រសិនបើបិទបង្អួច អ្នកមិនអាចមើលវាម្តងទៀតបានទេ ហើយត្រូវចេញថ្មីដើម្បីទទួលវាម្តងទៀត។",
    "reissuedNotice": "បានចេញថ្មី — តម្លៃភ្ជាប់ពីមុនមិនអាចប្រើបានទៀតទេ។",
    "guideTitle": "បញ្ចូលតម្លៃភ្ជាប់ក្នុងកម្មវិធី DJI",
    "guide": {
      "1": "ក្នុង DJI Pilot 2 (ឬកម្មវិធីកំណត់ Dock) សូមភ្ជាប់ទៅ Dock ហើយបើក “សេវាកម្មពពក”។",
      "2": "ជ្រើសរើស “ពពកភាគីទីបី” ហើយបញ្ចូលអាសយដ្ឋាន MQTT gateway គណនី និងម៉ាស៊ីនបម្រើ NTP។",
      "3": "ក្នុង “ការ Bind អង្គភាព” សូមបញ្ចូលលេខសម្គាល់អង្គភាព និងកូដ Bind ហើយបញ្ជាក់ឈ្មោះ Dock។",
      "4": "បន្ទាប់ពីរក្សាទុក Dock នឹងភ្ជាប់ទៅម៉ាស៊ីនបម្រើ។ សូមចុច បន្ទាប់ ហើយរង់ចាំការតភ្ជាប់។",
    },
    "waiting": "កំពុងរង់ចាំ Dock ភ្ជាប់ និងបញ្ចប់ការ Bind",
    "bound": "ការ Bind បានបញ្ចប់ — អ្នកអាចជ្រើសរើស Dock នេះនៅក្នុងរបារ Dock",
    "failed": "ការ Bind បរាជ័យ",
    "failure": {
      "invalid_binding_code": "កូដ Bind មិនត្រឹមត្រូវ",
      "organization_mismatch": "Dock នេះត្រូវបាន Bind ជាមួយអង្គភាពផ្សេង",
      "license_invalid": "ការផ្ទៀងផ្ទាត់អាជ្ញាប័ណ្ណ Dock បរាជ័យ",
      "sn_mismatch": "SN របស់ Dock ដែលបានភ្ជាប់ខុសពី SN ដែលបានចុះឈ្មោះ",
      "unknown": "ម៉ាស៊ីនបម្រើមិនបានប្រាប់មូលហេតុទេ",
    },
    "resumeIntro": "តម្លៃភ្ជាប់ពីមុនមិនអាចមើលម្តងទៀតបានទេ។ ប្រសិនបើចេញថ្មី តម្លៃពីមុននឹងអសុពលភាព ហើយតម្លៃថ្មីនឹងបង្ហាញតែម្តង។",
    "reissue": "ចេញតម្លៃភ្ជាប់ថ្មី",
    "next": "បន្ទាប់",
    "back": "ត្រឡប់ក្រោយ",
    "close": "បិទ",
    "done": "រួចរាល់",
    "copy": "ចម្លង {{label}}",
    "copied": "បានចម្លង",
  },
  "confirm": {
    "previewing": "ម៉ាស៊ីនមេកំពុងពិនិត្យបញ្ជានេះ",
    "previewFailed": "មិនអាចទទួលការមើលជាមុនបាន",
    "notSendable": "មិនអាចផ្ញើបានឥឡូវនេះ",
    "expired": "ការមើលជាមុនផុតកំណត់ — សូមបិទហើយបើកម្តងទៀត។ មិនបានផ្ញើសំណើទេ។",
    "cancel": "បោះបង់",
    "confirm": "បញ្ជាក់",
    "title": {
      "aircraft_limits": "ដាក់ដែនកំណត់យន្តហោះ",
      "eventAck": "បញ្ជាក់ការព្រមាន",
      "closeRecord": "កំណត់ត្រាបិទ",
      "aircraft": "ភ្ជាប់យន្តហោះ",
      "cover_open": "បើកគម្រប",
      "cover_close": "បិទគម្រប",
      "aircraft_power_on": "បើកថាមពលយន្តហោះ",
      "aircraft_power_off": "បិទថាមពលយន្តហោះ",
      "climate": "ផ្លាស់ប្តូរការត្រួតពិនិត្យអាកាសធាតុ",
      "pause": "ផ្អាកផ្លូវហោះហើរ",
      "resume": "បន្តផ្លូវហោះហើរ",
      "settings": "ផ្លាស់ប្តូរការកំណត់ហោះហើរ",
      "removeDock": "ដក Dock ចេញ",
    },
    "body": {
      "aircraft_limits": "ដាក់ដែនកំណត់ប្រវត្តិរូបហោះហើរលើយន្តហោះរបស់ {{dock}}។",
      "eventAck": "បញ្ជាក់ការព្រមាននៃ {{dock}}។ វានឹងលែងរារាំងការហោះឡើង។",
      "closeRecord": "រក្សាកំណត់ត្រាបិទសម្រាប់ {{dock}} — {{reason}}។",
      "aircraft": "ភ្ជាប់យន្តហោះ {{sn}} ទៅ {{dock}}។",
      "cover_open": "នឹងបើកគម្របរបស់ {{dock}}។",
      "cover_close": "នឹងបិទគម្របរបស់ {{dock}}។ សូមប្រាកដថាគ្មានមនុស្ស ឬវត្ថុនៅក្រោមគម្រប។",
      "aircraft_power_on": "នឹងបើកថាមពលយន្តហោះរបស់ {{dock}}។",
      "aircraft_power_off": "នឹងបិទថាមពលយន្តហោះរបស់ {{dock}}។",
      "climate": "នឹងប្តូរការត្រួតពិនិត្យអាកាសធាតុរបស់ {{dock}} ទៅ “{{mode}}”។",
      "pause": "នឹងផ្អាកការហោះហើរតាមផ្លូវរបស់ {{dock}}។ យន្តហោះនឹងដើរស្ថិតនៅនឹងកន្លែង។",
      "resume": "នឹងបន្តការហោះហើរតាមផ្លូវរបស់ {{dock}} ពីកន្លែងដែលបានឈប់។",
      "settings": "នឹងប្តូរកម្រិតកម្ពស់របស់ {{dock}} ទៅអតិបរមា {{max}} m និងអប្បបរមា {{min}} m។",
      "removeDock": "នឹងដក {{dock}} ចេញពីគម្រោងនេះ។ ដើម្បីប្រើម្តងទៀត អ្នកត្រូវ Bind ឡើងវិញពីដំបូង។",
    },
  },
  "leave": {
    "title": "Dock កំពុងហោះនៅលើអាកាស",
    "body": "ការហោះហើរនឹងបន្តទោះបីជាអ្នកចាកចេញពីទំព័រ ប៉ុន្តែប៊ូតុងត្រឡប់ និងការតាមដាននៅលើអេក្រង់នេះនឹងមិនអាចប្រើបានទៀតទេ។ ចាកចេញឬ?",
    "stay": "ស្នាក់នៅ",
    "leave": "ចាកចេញ",
  },
  "launch": {
    "blockedByPreparation": "ដោះស្រាយខាងក្រោមដើម្បីហោះឡើង",
    "checkFailed": "មិនបានបញ្ជាក់",
    "loginRemaining": "ពេលវេលាចូលនៅសល់",
    "loginMinutes": "{{minutes}} នាទី",
    "loginShort": "ការបាញ់ត្រូវការពេលចូលនៅសល់យ៉ាងតិច ៩០ នាទី — សូមចូលម្តងទៀត",
    "title": "ដំណើរការហោះហើរ — បញ្ជាក់ការហោះឡើង",
    "dock": "Dock គោលដៅ",
    "plan": "ផែនការ",
    "target": "ស៊េរីពេលវេលាដែលទទួលរូបថត",
    "figures": "ផ្លូវ {{distance}} · រូបថតប្រហែល {{photos}} · ប្រហែល {{minutes}} នាទី",
    "checklistLegend": "ពិនិត្យធាតុនីមួយៗដោយខ្លួនឯង ហើយធីកម្តងមួយៗ (មិនចងចាំទេ)",
    "validFor": "ការមើលជាមុនមានសុពលភាព {{seconds}} វិនាទីទៀត",
    "expired": "ការមើលជាមុនផុតសុពលភាពហើយ — សូមមើលជាមុនម្តងទៀត។ មិនបានផ្ញើសំណើទេ។",
    "reopen": "មើលជាមុនម្តងទៀត",
    "execute": "ហោះឡើង",
    "noAutoResend": "សំណើនឹងមិនត្រូវបានផ្ញើម្តងទៀតទេ នៅពេលផុតកំណត់",
    "previewing": "ម៉ាស៊ីនមេកំពុងរៀបចំការបញ្ជាក់ការហោះឡើង",
    "previewFailed": "មិនអាចទទួលបានការបញ្ជាក់ការហោះឡើងទេ — សូមមើលជាមុនម្តងទៀត",
    "blocked": "មិនអាចហោះឡើងបានទេឥឡូវនេះ",
  },
  "safety": {
    "regionLabel": "សុវត្ថិភាពហោះហើរ",
    "rth": "ត្រឡប់",
    "rthAria": "ត្រឡប់ {{dock}} — ចុចម្តងផ្ញើភ្លាមៗ",
    "rthStage": {
      "sending": "កំពុងផ្ញើ",
      "requested": "បានទទួលសំណើ — រង់ចាំការឆ្លើយតបពី Dock",
      "notSent": "មិនបានទទួលក្នុងរយៈពេល ៣ វិនាទី — សូមចុចម្តងទៀត",
      "refused": "Dock បដិសេធការត្រឡប់ — {{reason}}",
      "sendFailed": "មិនអាចផ្ញើបានទេ — សូមចុចម្តងទៀត",
      "sendFailedReason": "មិនអាចផ្ញើបានទេ: {{reason}} — សូមចុចម្តងទៀត",
      "returning": "កំពុងត្រឡប់",
      "landed": "ចុះចតរួចរាល់",
    },
    "rthAccepted": "បានផ្ញើសំណើត្រឡប់",
  },
  "attend": {
    "button": "កំពុងតាមដាន",
    "aria": "តាមដាន {{dock}} — បន្ថែមកាលកំណត់ត្រឡប់ពេលអ្នកប្រតិបត្តិការអវត្តមាន",
    "sending": "កំពុងផ្ញើការតាមដាន",
    "ok": "{{minutes}} នាទី {{seconds}} វិនាទី ទៀតដល់កាលកំណត់តាមដាន",
    "warning": "{{seconds}} វិនាទី មុនកាលកំណត់តាមដាន — សូមចុចឥឡូវនេះ",
    "overdue": "ហួសកាលកំណត់តាមដាន — ម៉ាស៊ីនបម្រើនឹងផ្ញើការត្រឡប់",
    "unknown": "មិនស្គាល់កាលកំណត់តាមដាន",
    "absentReturn": "បានចាប់ផ្តើមការត្រឡប់ ព្រោះអ្នកប្រតិបត្តិការអវត្តមាន",
  },
  "login": {
    "hours": "នៅសល់ {{hours}} ម៉ោង {{minutes}} នាទី ក្នុងការចូលគណនី",
    "minutes": "នៅសល់ {{minutes}} នាទី {{seconds}} វិនាទី ក្នុងការចូលគណនី",
    "unknown": "មិនស្គាល់ពេលវេលានៅសល់នៃការចូលគណនី",
    "expiring": "នៅសល់តិចជាង ១៥ នាទី ក្នុងការចូលគណនី — ឆាប់នឹងត្រូវចាកចេញ",
    "expired": "ការចូលគណនីផុតកំណត់ — សូមចូលម្តងទៀតបន្ទាប់ពីចុះចត",
  },
  "live": {
    "connecting": "កំពុងភ្ជាប់ទៅផ្ទាល់",
    "waitingStream": "កំពុងរង់ចាំដុកផ្ញើវីដេអូ",
    "playbackFailed": "មិនអាចចាក់វីដេអូផ្ទាល់បាន",
    "title": "{{dock}} ផ្សាយផ្ទាល់",
    "cameraLabel": "កាមេរ៉ា",
    "camera": {
      "dock": "កាមេរ៉ា Dock",
      "aircraft_wide": "យន្តហោះ មុំធំ",
      "aircraft_zoom": "យន្តហោះ ពង្រីក",
      "aircraft_ir": "យន្តហោះ កម្ដៅ",
    },
    "open": "មើលការផ្សាយផ្ទាល់",
    "start": "ចាប់ផ្តើមផ្សាយផ្ទាល់",
    "fullscreen": "ពេញអេក្រង់",
    "exitFullscreen": "ចាកចេញពីពេញអេក្រង់",
    "close": "បិទការផ្សាយផ្ទាល់",
    "notStarted": "គ្មានការផ្សាយផ្ទាល់ដែលបើកទេ",
    "viewerNotStarted": "អ្នកអាចមើលបាន នៅពេល owner បើកការផ្សាយផ្ទាល់",
    "mockSource": "វីដេអូគំរូសាកល្បង",
    "videoLabel": "វីដេអូ {{camera}} របស់ {{dock}}",
  },
  "mapping": {
    "title": "ការធ្វើផែនទី",
    "targetLabel": "ស៊េរីពេលវេលាគោលដៅ (កន្លែងទទួលរូបថត)",
    "targetNone": "គ្មានគោលដៅ",
    "targetEmpty": "មិនមានស៊េរីពេលវេលា before ដែលអាចទទួលរូបថតបានទេ — សូមបន្ថែមស៊េរីពេលវេលានៅលើអេក្រង់គម្រោង",
    "substitute": "ជំនួសគោលដៅគំរូសាកល្បង",
    "gate": {
      "noTarget": "សូមជ្រើសរើសស៊េរីពេលវេលា before ដើម្បីទទួលរូបថត",
      "notInProject": "នេះមិនមែនជាស៊េរីពេលវេលារបស់គម្រោងនេះទេ",
      "notBefore": "ស៊េរីពេលវេលានេះមិនស្ថិតក្នុងស្ថានភាព (before) ដែលអាចទទួលរូបថតបានទេ",
      "hasPhotos": "ស៊េរីពេលវេលាដែលបានផ្ទុកឡើងរូបថតដោយផ្ទាល់ មិនមែនជាគោលដៅធ្វើផែនទីរបស់ Dock ទេ",
      "pending": "កំពុងពិនិត្យស៊េរីពេលវេលា",
      "unreadable": "មិនអាចផ្ទុកបញ្ជីស៊េរីពេលវេលាបានទេ",
      "readOnly": "បានស្នើការធ្វើផែនទី — ផែនការ និងរូបថតនៃស៊េរីពេលវេលានេះអាចមើលបានតែប៉ុណ្ណោះ",
    },
  },
  "reference": {
    "label": "ស៊េរីពេលវេលាយោង (លទ្ធផល · ភូមិសាស្ត្រ)",
    "none": "គ្មានការយោង",
    "noReferenceWarning": "គ្មានស៊េរីពេលវេលាយោង ដូច្នេះមិនធ្វើការផ្ទៀងផ្ទាត់ការប៉ះទង្គិចទេ",
    "layers": "លទ្ធផលដែលត្រូវត្រួតគ្នា",
    "ortho": "Orthomosaic",
    "dsm": "DSM",
    "gis": "ស្រទាប់ GIS",
    "gisEmpty": "គម្រោងនេះមិនមានស្រទាប់ GIS ទេ",
    "no2d": "ការយោងនេះមិនមានលទ្ធផល 2D ទេ",
    "model3d": "មើលម៉ូដែល 3D និង BIM ក្នុងទិដ្ឋភាព 3D",
  },
  "plans": {
    "deleting": "កំពុងលុប — លុបម្តងទៀតដើម្បីបញ្ចប់",
    "title": "ផែនការហោះហើរ",
    "new": "ផែនការថ្មី",
    "empty": "មិនមានផែនការដែលបានរក្សាទុកទេ",
    "listLabel": "ផែនការហោះហើរដែលបានរក្សាទុក",
    "open": "បើក {{name}}",
    "duplicate": "ចម្លង {{name}}",
    "delete": "លុប {{name}}",
    "deleteTitle": "លុបផែនការ",
    "deleteMessage": "នឹងលុបផែនការ “{{name}}”",
    "deleteSub": "មិនអាចត្រឡប់វិញបានទេ បន្ទាប់ពីលុប",
    "import": "នាំចូលពីគម្រោងផ្សេង",
    "importTitle": "នាំចូលផែនការពីគម្រោងផ្សេង",
    "importEmpty": "មិនមានផែនការដែលអាចនាំចូលបានទេ",
    "importAction": "នាំចូល {{name}}",
    "importButton": "នាំចូល",
    "farWarning": "តំបន់នៃផែនការដែលបាននាំចូល “{{name}}” នៅឆ្ងាយពីទីតាំងការងារនេះ — សូមពិនិត្យតំបន់",
    "kmzBadge": "KMZ",
    "readOnly": "មើលតែប៉ុណ្ណោះ",
    "copySuffix": "(ច្បាប់ចម្លង)",
  },
  "area": {
    "title": "តំបន់ធ្វើផែនទី",
    "draw": "គូរតំបន់",
    "redraw": "គូរឡើងវិញ",
    "drawing": "ចុចចំណុចនៅលើផែនទី ហើយចុចពីរដងដើម្បីបញ្ចប់ (Esc ដើម្បីបោះបង់)",
    "cancel": "បោះបង់ការគូរ",
    "none": "មិនមានតំបន់ទេ",
    "points": "ចំនួនកំពូល {{count}}",
  },
  "params": {
    "speedCap": "ដែនកំណត់ដុកនេះ {{cap}} m/s — ដើម្បីហោះលឿនជាងនេះ សូមបង្កើនក្នុងការកំណត់",
    "title": "ការកំណត់ហោះហើរ និងថត",
    "name": "ឈ្មោះផែនការ",
    "mode": "ម៉ូដ",
    "modes": {
      "single_grid": "ក្រឡាតែមួយ",
      "double_grid": "ក្រឡាពីរ",
      "oblique": "ថតទ្រេត",
    },
    "gridAngle": "មុំក្រឡា (°)",
    "frontOverlap": "ការត្រួតគ្នាខាងមុខ (%)",
    "sideOverlap": "ការត្រួតគ្នាចំហៀង (%)",
    "altitude": "កម្ពស់ហោះហើរ (m)",
    "speed": "ល្បឿន (m/s)",
    "camera": "កាមេរ៉ា",
    "cameras": {
      "visible": "ពន្លឺមើលឃើញ",
      "thermal": "កម្ដៅ",
      "both": "ទាំងពីរ",
    },
    "overlapBasis": "មូលដ្ឋានការត្រួតគ្នា",
    "obliquePattern": "គំរូថតទ្រេត",
    "obliquePatterns": {
      "single_grid": "ក្រឡាតែមួយ",
      "double_grid": "ក្រឡាពីរ",
      "five_direction": "៥ ទិស",
    },
    "obliqueTilt": "ទិសទ្រេត",
    "obliqueTilts": {
      "along_track": "ទិសដំណើរ",
      "cross_track": "ទិសចំហៀង",
    },
    "obliqueTiltHelp": "ទិសចំហៀងមើលទិសពីរដែលកែងនឹងបន្ទាត់។ ប្រើសម្រាប់រក្សាបន្ទាត់វែង ខណៈថតផ្នែកចំហៀងនៃតំបន់វែង ដូចជាផ្លូវ ទន្លេ និងជម្រាល",
    "gimbalPitch": "មុំកាមេរ៉ា (°)",
    "includeNadir": "រួមបញ្ចូលការហោះថតត្រង់ចុះក្រោម",
    "sameDirectionOverlap": "ការត្រួតគ្នាចំហៀងរវាងរូបថតទិសដូចគ្នាគឺ {{same}}% — បើត្រូវការច្រើនជាងនេះ សូមបង្កើនការត្រួតគ្នាចំហៀង ឬប្រើ ៥ ទិស",
    "flightAreaHelp": "តំបន់ផែនទីដែលបានគូរគឺជាតំបន់ថត។ បន្ទាត់ទ្រេតហោះចេញទៅតំបន់ហោះហើរនៅក្រៅវា ហើយការហោះក្រៅតំបន់ឆ្លងកាត់ពីលើដីជិតខាង។ មានតែស្រោមចម្ងាយ Dock ប៉ុណ្ណោះដែលកំណត់វា",
    "save": "រក្សាទុកផែនការ",
    "saved": "បានរក្សាទុកផែនការ",
  },
  "preview": {
    "title": "មើលជាមុន (ប៉ាន់ស្មាន)",
    "figures": "បន្ទាត់ {{lines}} · រូបថតប្រហែល {{photos}} · {{distance}} · ប្រហែល {{minutes}} នាទី · GSD {{gsd}} cm/px",
    "invalid": "កែតំបន់ និងការកំណត់ ដើម្បីមើលជាមុន",
    "obliqueFigures": "ការហោះ {{passes}} · ទិសមើល {{directions}} · GSD ទ្រេត {{gsd}} cm/px · ក្រៅតំបន់អតិបរមា {{outside}}",
    "covered": "តំបន់ទាំងមូលស្ថិតក្នុងតំបន់គ្រោះថ្នាក់ និងចន្លោះការពារ ដូច្នេះគ្មានបន្ទាត់ហោះហើរទេ",
  },
  "planForm": {
    "problem": {
      "required": "សូមបញ្ចូលតម្លៃ",
      "notNumber": "សូមបញ្ចូលលេខ",
      "outOfRange": "សូមបញ្ចូលតម្លៃចន្លោះពី {{min}} ដល់ {{max}}",
      "tooLong": "សូមបញ្ចូលមិនលើស {{max}} តួអក្សរ",
      "tooFewPoints": "សូមគូរតំបន់ដោយប្រើចំណុចយ៉ាងតិច {{min}}",
    },
  },
  "hazards": {
    "title": "សំណង់ និងតំបន់គ្រោះថ្នាក់",
    "draw": "គូរតំបន់គ្រោះថ្នាក់",
    "show": "បង្ហាញលើផែនទី",
    "empty": "មិនមានសំណង់ ឬតំបន់គ្រោះថ្នាក់ដែលបានចុះឈ្មោះទេ",
    "drawing": "គូរពហុកោណនៅលើផែនទី (ចុចពីរដងដើម្បីបញ្ចប់ Esc ដើម្បីបោះបង់)",
    "formTitle": "រក្សាទុកសំណង់ ឬតំបន់គ្រោះថ្នាក់",
    "kind": {
      "facility": "សំណង់",
      "area": "តំបន់",
    },
    "kindLabel": "ប្រភេទ",
    "name": "ឈ្មោះ",
    "height": "កម្ពស់ (m ជម្រើស)",
    "heightValue": "កម្ពស់ {{height}} m",
    "noHeight": "មិនបានកំណត់កម្ពស់",
    "save": "រក្សាទុក",
    "cancel": "បោះបង់",
    "delete": "លុប {{name}}",
    "alwaysAvoids": "ទោះបីបិទការបង្ហាញក៏ដោយ ផ្លូវតែងតែបង្កើតឱ្យឆ្ងាយពីតំបន់គ្រោះថ្នាក់ {{buffer}} m ហើយនឹងត្រូវរារាំងប្រសិនបើមិនអាចជៀសបាន",
    "problem": {
      "nameRequired": "សូមបញ្ចូលឈ្មោះ",
      "height": "សូមបញ្ចូលលេខចន្លោះពី 0 ដល់ 1000",
    },
  },
  "route": {
    "deleting": "ការលុបផ្លូវនេះបានឈប់ពាក់កណ្តាល — សូមបង្កើតម្តងទៀត",
    "profileFailed": "មិនអាចអានផ្នែកកាត់ផ្លូវបាន",
    "title": "ផ្លូវ",
    "generate": "បង្កើត និងផ្ទៀងផ្ទាត់ផ្លូវ",
    "regenerate": "បង្កើតឡើងវិញ",
    "invalid": {
      "noDock": "សូមជ្រើសរើស Dock នៅក្នុងរបារ Dock",
      "missing": "មិនមានផ្លូវសម្រាប់ផែនការ និង Dock នេះទេ — សូមបង្កើត",
      "otherDock": "ផ្លូវនេះត្រូវបានបង្កើតសម្រាប់ Dock ផ្សេង — សូមបង្កើតឡើងវិញ",
      "stalePlan": "ផែនការបានផ្លាស់ប្តូរ — សូមបង្កើតឡើងវិញ",
      "hazardsChanged": "តំបន់គ្រោះថ្នាក់បានផ្លាស់ប្តូរ — សូមបង្កើតឡើងវិញ",
      "blocked": "ផ្លូវត្រូវបានបិទ ហើយមិនអាចដំណើរការបានទេ",
    },
    "block": {
      "hazard": "ត្រូវបានបិទ ព្រោះឆ្លងកាត់តំបន់គ្រោះថ្នាក់ “{{name}}”",
      "hazard_takeoff_inside": "មិនអាចបង្កើតផ្លូវបានទេ ព្រោះ Dock ស្ថិតក្នុងតំបន់គ្រោះថ្នាក់ «{{names}}»",
      "hazard_area_covered": "មិនអាចបង្កើតផ្លូវបានទេ ព្រោះតំបន់ទាំងមូលស្ថិតក្នុងតំបន់គ្រោះថ្នាក់ «{{names}}» និងចន្លោះការពារ",
      "hazard_unreachable": "មិនអាចបង្កើតផ្លូវបានទេ ព្រោះគ្មានបន្ទាត់ហោះហើរដែល Dock អាចទៅដល់ — «{{names}}» រារាំងផ្លូវ",
      "hazard_detour_limit": "មិនអាចបង្កើតផ្លូវបានទេ ព្រោះផ្លូវវាងលើសដែនកំណត់ Waypoint ចម្ងាយ ឬការហោះមួយដង — «{{names}}»",
      "hazard_waypoint_inside": "មិនអាចបង្កើតផ្លូវបានទេ ព្រោះ Waypoint ស្ថិតក្នុងតំបន់គ្រោះថ្នាក់ «{{names}}»",
    },
    "figures": "Waypoint {{waypoints}} · រូបថតប្រហែល {{photos}} · {{distance}} · ប្រហែល {{minutes}} នាទី",
    "obliqueSummary": "ទ្រេត {{pattern}}{{tilt}} · ការហោះ {{passes}} · ក្រៅតំបន់អតិបរមា {{lead}}",
    "ready": "ផ្លូវនេះអាចដំណើរការបាន",
    "collision": "ផ្នែកដែលអាចប៉ះទង្គិច {{count}} កន្លែង — គម្លាតពីភូមិសាស្ត្រ ឬសំណង់តិចជាង {{threshold}} m",
    "noCollision": "គ្មានផ្នែកដែលអាចប៉ះទង្គិចជាមួយកាត់ទទឹងនៃស៊េរីពេលវេលាយោងទេ",
    "noReference": "គ្មានស៊េរីពេលវេលាយោង ដូច្នេះមិនបង្ហាញកាត់ទទឹង និងសញ្ញាប៉ះទង្គិចទេ",
    "needSavedPlan": "រក្សាទុកផែនការ ដើម្បីបង្កើតផ្លូវ",
    "avoidance": "បានជៀសតំបន់គ្រោះថ្នាក់ {{count}} · ផ្លូវវាង +{{bypass}} · ផ្ទៃមិនបានថត {{area}} m² ({{ratio}}%)",
    "warning": {
      "hazard_waypoint_buffer": "ចំណុចផ្លូវនៅក្នុងរឹមតំបន់គ្រោះថ្នាក់ — {{names}}",
      "hazard_excluded_area": "ផ្ទៃដែលបានដកចេញ {{area}} m² ({{ratio}}%) — គ្មានបន្ទាត់ហោះហើរឆ្លងកាត់ទីនេះទេ",
      "hazard_unreachable_part": "បានដកផ្នែកដែលមិនអាចទៅដល់ {{area}} m² — វាត្រូវបានហ៊ុំព័ទ្ធ គ្មានផ្លូវចូល",
      "hazard_short_fragment": "បំណែកខ្លី — ដកចេញ {{dropped}} ({{length}}) រក្សាទុក {{kept}}។ បំណែកដែលរក្សាទុកអាចខ្វះការត្រួតគ្នារូបថត",
      "hazard_edge_gap": "ដោយសារកម្ពស់ទាប ចន្លោះការពារ ({{buffer}} m) លើសពាក់កណ្តាលទទឹងថត — អាចមានចន្លោះរូបថតនៅគែមតំបន់គ្រោះថ្នាក់",
      "hazard_takeoff_buffer": "Dock ស្ថិតក្នុងចន្លោះការពាររបស់ «{{names}}»",
      "hazard_return_reach": "ការត្រឡប់បន្ទាន់ហោះត្រង់ទៅ Dock ហើយអាចឆ្លងកាត់ពីលើ «{{names}}»",
    },
  },
  "legend": {
    "title": "សញ្ញាពន្យល់",
    "nadirPass": "ការហោះបញ្ឈរ {{index}}",
    "obliquePass": "ការហោះទ្រេត {{index}} · ទិសមើល {{bearings}}",
    "obliquePassSide": "ការហោះទ្រេត {{index}} · មើលកែងនឹងបន្ទាត់ {{bearings}}",
    "route": "ផ្លូវ",
    "bypass": "ផ្លូវវាង",
    "transit": "ផ្នែកធ្វើដំណើរ (Dock ↔ ផ្លូវ)",
    "pathStart": "សញ្ញាចាប់ផ្តើម S",
    "pathEnd": "សញ្ញាបញ្ចប់ E",
    "returnExposure": "ផ្នែកប៉ះពាល់ពេលត្រឡប់",
    "collision": "ផ្នែកអាចបុកទង្គិច",
    "excluded": "ផ្ទៃដែលបានដកចេញ",
    "unreachable": "ផ្នែកមិនអាចទៅដល់",
    "hazard": "តំបន់គ្រោះថ្នាក់",
    "causeHazard": "តំបន់ដើមហេតុ (រារាំង ឬធ្វើឱ្យផ្លូវវាង)",
    "area": "តំបន់ថត (តំបន់ផែនទី)",
    "flightArea": "តំបន់ហោះហើរ · ក្រៅតំបន់អតិបរមា {{outside}}",
    "waypoint": "Waypoint",
    "photo": "ចំណុចថត",
    "sight": "សញ្ញាខ្សែមើល",
    "dock": "ដុក",
    "dockScene": "ដុក និងខ្សែកម្ពស់ត្រឡប់",
  },
  "profile": {
    "title": "កាត់ទទឹងផ្លូវ",
    "aria": "កាត់ទទឹងផ្លូវ — ភូមិសាស្ត្រ និងកម្ពស់ហោះហើរក្នុងចម្ងាយ {{distance}} ផ្នែកដែលអាចប៉ះទង្គិច {{count}} កន្លែង",
    "terrain": "ភូមិសាស្ត្រ",
    "flight": "ការហោះហើរ",
    "collision": "អាចប៉ះទង្គិច",
  },
  "flight": {
    "aircraftPending": "កំពុងបញ្ជាក់ការតភ្ជាប់យន្តហោះ",
    "profileIncomplete": "ប្រវត្តិរូបហោះហើរមិនពេញលេញ — សូមបំពេញក្នុងការកំណត់",
    "title": "ការហោះហើរ",
    "run": "ដំណើរការហោះហើរ",
    "phase": {
      "preparing": "កំពុងរៀបចំ",
      "takeoff": "ហោះឡើង",
      "en_route": "កំពុងធ្វើដំណើរ",
      "mapping": "កំពុងថត",
      "returning": "កំពុងត្រឡប់",
      "landing": "កំពុងចុះចត",
      "landed": "ចុះចតរួចរាល់",
      "failed": "បរាជ័យ",
    },
    "paused": "បានផ្អាក",
    "pause": "ផ្អាក",
    "resume": "បន្ត",
    "progress": "Waypoint {{index}}/{{total}} · {{percent}}%",
    "battery": "ថ្ម {{percent}}%",
    "photos": "រូបថតសរុប {{count}}",
    "openLive": "ផ្សាយផ្ទាល់",
    "needRoute": "មិនមានផ្លូវដែលអាចដំណើរការបានទេ",
    "dockBusy": "Dock នេះកំពុងហោះហើររួចហើយ",
    "needTarget": "សូមជ្រើសរើសស៊េរីពេលវេលាគោលដៅដែលទទួលរូបថត",
    "launched": "បានផ្ញើសំណើហោះឡើង",
  },
  "request": {
    "title": "សំណើធ្វើផែនទី",
    "action": "ស្នើការធ្វើផែនទី",
    "flying": "មិនអាចស្នើបានទេ ពេលកំពុងហោះហើរ",
    "noPhotos": "មិនទាន់បានទទួលរូបថតនៅឡើយទេ",
    "substituteTitle": "សំណើធ្វើផែនទីស៊េរីពេលវេលាជំនួស",
    "substituteBody": "នេះជាការជំនួសគោលដៅគំរូសាកល្បង ដូច្នេះមិនផ្ញើទៅម៉ាស៊ីនបម្រើពិតទេ ហើយផ្លាស់ប្តូរតែស្ថានភាពនៅលើអេក្រង់នេះប៉ុណ្ណោះ។",
    "done": "សំណើបានបញ្ចប់",
  },
  "flightCheck": {
    "terrainVersion": "កំណែដីដែលបានត្រួតពិនិត្យ: {{version}}",
    "title": "ការត្រួតពិនិត្យហោះហើរ",
    "run": "ដំណើរការត្រួតពិនិត្យ",
    "rerun": "ត្រួតពិនិត្យម្តងទៀត",
    "passed": "ជាប់ · {{time}}",
    "problem": {
      "unchecked": "មិនទាន់បានត្រួតពិនិត្យហោះហើរ",
      "failed": "ការត្រួតពិនិត្យមិនជាប់",
      "stale": "កំណត់ត្រាហួសសម័យ — សូមត្រួតពិនិត្យម្តងទៀត",
    },
    "stale": {
      "profile_changed": "ប្រវត្តិរូបហោះហើរបានផ្លាស់ប្តូរ",
      "hazards_changed": "តំបន់គ្រោះថ្នាក់បានផ្លាស់ប្តូរ",
      "terrain_changed": "ដីបានផ្លាស់ប្តូរ",
      "validator_changed": "កម្មវិធីត្រួតពិនិត្យបានផ្លាស់ប្តូរ",
      "validator_unreviewed": "កម្មវិធីត្រួតពិនិត្យមិនទាន់ពិនិត្យ",
      "kmz_changed": "ឯកសារផ្លូវបានផ្លាស់ប្តូរ",
    },
  },
  "preparation": {
    "title": "ការរៀបចំហោះហើរ",
    "residual": "ការហោះហើរមុនរបស់ដុកនេះមិនទាន់បិទ — សូមបញ្ជាក់ការចុះចត ហើយកត់ត្រា",
    "eventNotFound": "រកមិនឃើញការព្រមាននៅទីនេះ — {{reason}} (ព្រឹត្តិការណ៍ {{id}})។ សូមដោះស្រាយតាមវិធីផ្សេងដោយប្រើលេខព្រឹត្តិការណ៍។",
    "limitsIntro": "បើកយន្តហោះ ដាក់ដែនកំណត់ប្រវត្តិរូប រួចបិទ។ ម៉ាស៊ីនមេពិនិត្យរាល់ជំហាន។ បន្តបន្ទាប់ពីវាបើក។",
    "power": "ថាមពលយន្តហោះ: {{state}}",
    "stepSent": "បានផ្ញើ",
    "stepRun": "ដំណើរការ",
    "done": "បញ្ចប់",
    "closeIntro": "កំណត់ត្រាដែលមនុស្សសរសេរអំពីការចុះចតដែលម៉ាស៊ីនមេខកខាន។ សូមពិនិត្យទីតាំងយន្តហោះដោយខ្លួនឯង រួចជ្រើសរើស។",
    "closeNext": "មើលជាមុន",
    "reasonLabel": "មូលហេតុ",
    "noteLabel": "កំណត់ចំណាំ (ស្រេចចិត្ត)",
    "action": {
      "limits": "រៀបចំដែនកំណត់យន្តហោះ",
      "ack": "បញ្ជាក់ការព្រមាន",
      "close": "កំណត់ត្រាបិទ",
    },
    "step": {
      "power_on": "បើកយន្តហោះ",
      "limits": "ដាក់ដែនកំណត់យន្តហោះ",
      "power_off": "បិទយន្តហោះ",
    },
    "reason": {
      "in_dock_visual": "នៅក្នុងដុក (មើលឃើញ)",
      "landed_outside_visual": "ចុះចតក្រៅដុក (មើលឃើញ)",
      "recovered_outside_dock": "យកមកវិញក្រៅដុក",
      "lost": "បាត់",
      "destroyed": "ខូច",
    },
    "reasonHint": {
      "in_dock_visual": "អ្នកបានឃើញយន្តហោះនៅក្នុងដុក។ ការរៀបចំបន្ទាប់ត្រូវការកំណត់ត្រានេះ។",
      "landed_outside_visual": "អ្នកបានឃើញយន្តហោះចុះចតក្រៅដុក។",
      "recovered_outside_dock": "យន្តហោះត្រូវបានយកមកវិញក្រៅដុក។",
      "lost": "រកយន្តហោះមិនឃើញ។",
      "destroyed": "យន្តហោះខូច។",
    },
  },
  "settings": {
    "profile": "ប្រវត្តិរូបហោះហើរ",
    "profileUnreadable": "មិនអាចអានប្រវត្តិរូបបាន",
    "incomplete": "ប្រវត្តិរូបមិនពេញលេញ — មិនអាចហោះហើរបាន",
    "digest": "digest ដែលបានរក្សាទុក {{digest}}",
    "groupRequired": "ចាំបាច់",
    "groupLimits": "ដែនកំណត់ហោះហើរ",
    "groupTakeoff": "លក្ខខណ្ឌហោះឡើង",
    "groupWatch": "តម្លៃតាមដាន និងបញ្ជា",
    "positionSuggested": "បានបំពេញទីតាំងដែលដុករាយការណ៍ — ត្រូវរក្សាទុកទើបមានប្រសិទ្ធភាព",
    "fieldRequired": "សូមបញ្ចូលតម្លៃ",
    "fieldRange": "{{min}}–{{max}}",
    "saveProfile": "រក្សាទុកប្រវត្តិរូប",
    "confirmChanged": "ការផ្លាស់ប្តូរ: {{fields}}",
    "confirmNoChange": "គ្មាន",
    "confirmDigest": "៨ តួដំបូងនៃ digest ថ្មី: {{digest}}",
    "confirmComplete": "ប្រវត្តិរូបនឹងពេញលេញ",
    "confirmIncomplete": "នៅតែមិនពេញលេញ: {{problems}}",
    "aircraftLimits": "ដែនកំណត់យន្តហោះរំពឹងទុក",
    "changes": "ប្រវត្តិផ្លាស់ប្តូរ",
    "changesEmpty": "មិនទាន់មានការផ្លាស់ប្តូរ",
    "climateSaved": "របៀបដែលបានរក្សាទុក: {{mode}}",
    "climateSave": "រក្សាទុករបៀប",
    "field": {
      "latitude": "រយៈទទឹងដុក",
      "longitude": "រយៈបណ្តោយដុក",
      "height_m": "កម្ពស់អេលីបសូអ៊ីតដុក (m)",
      "dock_position": "ទីតាំងដុក",
      "max_distance_m": "ចម្ងាយអតិបរមា (m)",
      "max_height_m": "កម្ពស់អតិបរមា (m)",
      "min_height_m": "កម្ពស់អប្បបរមា (m)",
      "rth_altitude_m": "កម្ពស់ត្រឡប់ (m)",
      "permit_ceiling_m": "ពិដានអនុញ្ញាត (m)",
      "max_speed_mps": "ល្បឿនអតិបរមា (m/s)",
      "temp_min_c": "សីតុណ្ហភាពអប្បបរមា (℃)",
      "temp_max_c": "សីតុណ្ហភាពអតិបរមា (℃)",
      "max_wind_mps": "ល្បឿនខ្យល់អតិបរមា (m/s)",
      "min_battery_pct": "ថ្មអប្បបរមា (%)",
      "min_gnss_quality": "គុណភាព GNSS អប្បបរមា",
      "min_gps_number": "ផ្កាយរណបអប្បបរមា",
      "link_stable_s": "ការតភ្ជាប់ស្ថិរភាព (វិនាទី)",
      "breach_margin_m": "រឹមតាមដានការចេញ (m)",
      "position_tolerance_m": "កម្រិតអនុញ្ញាតទីតាំងដុក (m)",
      "attend_timeout_s": "តាមដានប្រតិបត្តិករអវត្តមាន (វិនាទី)",
      "telemetry_lost_s": "បាត់ទូរមាត្រ (វិនាទី)",
      "route_max_points": "ចំណុចផ្លូវអតិបរមា",
      "hover_max_s": "ការហោះនៅនឹងកន្លែងអតិបរមា (វិនាទី)",
      "stick_max_deflection": "ការបត់ដំបងអតិបរមា",
      "stick_session_max_s": "រយៈពេលវគ្គបញ្ជា (វិនាទី)",
      "stick_floor_m": "កម្រិតទាបដំបង (m ឬ off)",
      "stick_descent_mps": "ល្បឿនចុះកម្រិតទាប",
      "climate_mode": "របៀបត្រជាក់ដុក",
      "obstacle_avoidance": "ការរកឃើញឧបសគ្គ",
    },
    "title": "ការកំណត់ដ្រូន",
    "selectDock": "សូមជ្រើសរើស Dock នៅក្នុងរបារ Dock",
    "viewOnly": "សិទ្ធិមើលប៉ុណ្ណោះ — មិនអាចប្តូរការកំណត់បានទេ",
    "loadFailed": "មិនអាចផ្ទុកការកំណត់បានទេ",
    "climate": "សីតុណ្ហភាពខាងក្នុង Dock",
    "climateCurrent": "បច្ចុប្បន្ន {{temperature}} · {{state}}",
    "climateModes": {
      "off": "បិទ",
      "cooling": "ធ្វើឱ្យត្រជាក់",
      "heating": "ធ្វើឱ្យក្តៅ",
    },
    "climateApply": "អនុវត្តការត្រួតពិនិត្យអាកាសធាតុ",
    "envelopeAria": "ស្រោមកម្ពស់ — ហោះហើរចន្លោះពីអប្បបរមា {{min}} m ដល់អតិបរមា {{max}} m",
    "obstacle": "ការរកឃើញឧបសគ្គ",
    "obstacleOn": "បើក",
    "obstacleNote": "ការបិទមិនត្រូវបានផ្ញើពីអេក្រង់នេះទេ",
    "kmz": "ផ្ទុកឡើង KMZ",
    "kmzSelect": "ជ្រើសរើសឯកសារ KMZ",
    "kmzNote": "ផ្លូវដែលបានផ្ទុកឡើងនឹងចូលបញ្ជីផែនការជាប្រភេទមើលតែប៉ុណ្ណោះ។ វាមិនត្រូវបានកែទេ ដូច្នេះនឹងត្រូវរារាំងប្រសិនបើឆ្លងកាត់តំបន់គ្រោះថ្នាក់ ហើយក៏ឆ្លងកាត់ការផ្ទៀងផ្ទាត់កម្ពស់ផងដែរ",
    "kmzOnly": "អាចផ្ទុកឡើងបានតែឯកសារ KMZ (.kmz) ប៉ុណ្ណោះ",
    "kmzDone": "បាននាំចូល “{{name}}”",
  },
  "map": {
    "flatBase3d": "គ្មានលទ្ធផល 3D — គូរលើផ្ទៃផ្កាយរណបរាបស្មើ (គ្មានសណ្ឋានដី)",
    "dock": "Dock {{name}}",
    "aircraft": "យន្តហោះ {{name}}",
    "readOnly3d": "3D សម្រាប់មើលតែប៉ុណ្ណោះ — ការគូរធ្វើក្នុង 2D",
  },
  "units": {
    "meters": "{{value}} m",
    "kilometers": "{{value}} km",
    "celsius": "{{value}} ℃",
    "percent": "{{value}}%",
    "mps": "{{value}} m/s",
  },
} as const;

export default drone;
